class SwatchTooltip extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.observeVisibility();
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect(); // Clean up when disconnected
    }
  }

  observeVisibility() {
    const options = {
      root: null, // Use the viewport as the root
      rootMargin: '0px', // No margin around the root
      threshold: 0.01 // Trigger callback when 1% or more of the element is visible
    };

    this.observer = new IntersectionObserver(this.handleIntersection.bind(this), options);

    // Start observing the tooltip element
    this.observer.observe(this);
  }

  handleIntersection(entries, observer) {
    entries.forEach(entry => {
      // Trigger logic when 1% or more but less than 100% of the element is visible
      if (entry.intersectionRatio >= 0.01 && entry.intersectionRatio < 1) {
        // Calculate how much of it is cropped
        const boundingRect = entry.boundingClientRect;
        const intersectionRect = entry.intersectionRect;

        // Calculate the cropped width
        const leftCrop = Math.max(0, intersectionRect.left - boundingRect.left);
        const rightCrop = Math.max(0, boundingRect.right - intersectionRect.right);

        if (leftCrop > rightCrop) {
          this.style.left = `calc(50% + ${leftCrop + 2}px)`;
        } else if (rightCrop > leftCrop) {
          this.style.left = `calc(50% + -${rightCrop + 2}px)`;
        }
      }
    });
  }
}

customElements.define('swatch-tooltip', SwatchTooltip);
